var React = require('react');

function PlayButtonIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"40","cy":"40","fill":"#FECE3E","r":"40","key":0}),React.createElement("path",{"d":"M56.0002 40L32.0002 53.8564L32.0002 26.1436L56.0002 40Z","fill":"#194550","key":1})]);
}

PlayButtonIcon.defaultProps = {"fill":"none","height":"80","viewBox":"0 0 80 80","width":"80"};

module.exports = PlayButtonIcon;

PlayButtonIcon.default = PlayButtonIcon;
